import React, { FC, ReactElement, ReactNode } from 'react'

function locateChild(tag: FC, children?: ReactNode) {
  let child: any = null
  React.Children.forEach(children, (c: any) => {
    if (c.type === tag) {
      child = child || c
    }
  })
  return child && child.props.children
}

function childByTagOr(
  tag: FC,
  defValue?: ReactElement | (() => ReactElement),
  children?: ReactNode
) {
  const val = defValue || locateChild(tag, children)

  if (typeof val === 'function') {
    return val()
  }
  return val ?? null
}

export { childByTagOr, locateChild }
